// Member org (2026-10-28). localStorage 'orgId' is written only by the GUEST paths (guestGate.js
// commitGuestSession, guestSignIn.ts reResolveGuestOrg) and member sign-in never touched it, so a
// browser that once ran a guest session kept that org — including the fictional
// '123sdfgy…' id — and every later MEMBER session was filed under it.

const memberOrgIdOf = (user: any): string => {
  const org = user?.org;
  if (!org || typeof org !== 'object') return '';
  return org.orgId || org.id || '';
};

/** Member sign-in: 'orgId' becomes the member's own org (removed when they have none), and the
 *  guest-only 'orgSource' / 'orgBotId' are dropped. */
export function commitMemberOrg(storage: Storage, user: any): void {
  const orgId = memberOrgIdOf(user);
  if (orgId) storage.setItem('orgId', orgId);
  else storage.removeItem('orgId');
  storage.removeItem('orgSource');
  storage.removeItem('orgBotId');
}

/** Authed session metadata: the member's own org FIRST, stored 'orgId' only as the fallback. */
export function resolveMemberOrgId(user: any, storage: Storage): string {
  return memberOrgIdOf(user) || storage.getItem('orgId') || '';
}
